import { render, staticRenderFns } from "./CensusUpload.vue?vue&type=template&id=9977ed18&scoped=true"
import script from "./CensusUpload.vue?vue&type=script&lang=ts"
export * from "./CensusUpload.vue?vue&type=script&lang=ts"
import style0 from "./CensusUpload.vue?vue&type=style&index=0&id=9977ed18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9977ed18",
  null
  
)

export default component.exports